import React, { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface PublicRouteProps {
  children: ReactNode;
}

const PublicRoute: FC<PublicRouteProps> = ({ children }) => {
  const authToken = localStorage.getItem('api_token');
  const userType = localStorage.getItem('userType'); // assuming you save it after login

  if (authToken) {
    // Redirect based on userType
    if (userType === 'employer') {
      return <Navigate to="/employer" replace />;
    } else if (userType === 'seeker') {
      return <Navigate to="/employee" replace />;
    } else {
      // Fallback if userType is not valid
      return <Navigate to="/" replace />;
    }
  }

  return <>{children}</>;
};

export default PublicRoute;
